import { css } from '@emotion/core'

/**
 * Hides content visually but leaves it available to screen readers.
 * Based on standard strict "visually hidden" / "sr-only" patterns.
 */
export const visuallyHiddenCss = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
